module.exports = __webpack_public_path__ + "img/tc.f85cadec.svg";